<template>
  <div v-if="animalToUpdate && animalToUpdate.id">
    <breadcrumb :items="breadcrumbs"></breadcrumb>
    <div class="animal">
      <v-container fluid>
        <div class="animal__header px-8 py-5" elevation="0" color="transparent">
          <h3># {{ $route.params.animal_number }}</h3>
          {{ animalToUpdate.name }}

          <v-card>
            <v-card-text class="c-right">
              <v-card flat>
                <v-card-title>
                  <v-row class="elevation-0" width="100%">
                    <v-col cols="1.5" class="">
                      <v-list dense>
                        <v-list-item>
                          <v-list-item-content>
                            <v-list-item-subtitle>
                              {{ $t("farmName") }}
                            </v-list-item-subtitle>
                            <v-list-item-title
                              class="text-h6 mt-2 text-capitalize"
                            >
                              {{
                                animalToUpdate.farm &&
                                animalToUpdate.farm.farmName
                                  ? animalToUpdate.farm.farmName
                                  : ""
                              }}
                            </v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                      </v-list>
                    </v-col>
                    <v-divider vertical inset></v-divider>
                    <v-col cols="2" class="">
                      <v-list dense>
                        <v-list-item>
                          <v-list-item-content>
                            <v-list-item-subtitle>
                              {{ $t("animal.species") }}
                            </v-list-item-subtitle>
                            <v-list-item-title
                              class="text-h6 mt-2 text-capitalize"
                            >
                              {{
                                animalToUpdate.specie
                                  ? animalToUpdate.specie.name
                                  : ""
                              }}
                            </v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                      </v-list>
                    </v-col>
                    <v-divider vertical inset></v-divider>
                    <v-col cols="2" class="">
                      <v-list dense>
                        <v-list-item>
                          <v-list-item-content>
                            <v-list-item-subtitle>
                              {{ $t("animal.gender") }}
                            </v-list-item-subtitle>
                            <v-list-item-title
                              class="text-h6 mt-2 text-capitalize"
                            >
                              {{ animalToUpdate.gender }}
                            </v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                      </v-list>
                    </v-col>
                    <v-divider vertical inset></v-divider>
                    <v-col cols="2" class="">
                      <v-list dense>
                        <v-list-item>
                          <v-list-item-content>
                            <v-list-item-subtitle>
                              {{ $t("animal.breed") }}
                            </v-list-item-subtitle>
                            <v-list-item-title
                              class="text-h6 mt-2 text-capitalize"
                            >
                              {{
                                animalToUpdate.breed
                                  ? animalToUpdate?.breed.name
                                  : animalToUpdate?.breedName
                                  ? animalToUpdate?.breedName
                                  : ""
                              }}
                            </v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                      </v-list>
                    </v-col>
                    <v-divider vertical inset></v-divider>
                    <v-col cols="2" class="">
                      <v-list dense>
                        <v-list-item>
                          <v-list-item-content>
                            <v-list-item-subtitle>
                              {{ $t("animal.class") }}
                            </v-list-item-subtitle>
                            <v-list-item-title
                              class="text-h6 mt-2 text-capitalize"
                            >
                              {{
                                animalToUpdate.animalClasses
                                  ? animalToUpdate.animalClasses.map(obj => obj.name).join(', ')
                                  : ""
                              }}
                            </v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                      </v-list>
                    </v-col>
                    <v-divider vertical inset></v-divider>
                    <v-col cols="2" class="">
                      <v-list dense>
                        <v-list-item>
                          <v-list-item-content>
                            <v-list-item-subtitle>
                              {{ $t("category") }}
                            </v-list-item-subtitle>
                            <v-list-item-title
                              class="text-h6 mt-2 text-capitalize"
                            >
                              {{
                                animalToUpdate.animalCategories
                                  ? animalToUpdate.animalCategories.map(obj => obj.name).join(', ')
                                  : ""
                              }}
                            </v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                      </v-list>
                    </v-col>
                  </v-row>
                </v-card-title>
              </v-card>
              <router-view :animal="animal" />
            </v-card-text>
          </v-card>
        </div>
        <!-- {{ animalCategoriesFlag }}animalCategoriesFlag<br>
{{ breedsFlag }}breedsFlag<br>
{{ classesFlag }}classesFlag<br>
{{ farmsFlag }}farmsFlag<br>
{{ farmTypesFlag }}farmTypesFlag<br>
{{ speciesFlag }}speciesFlag<br>
{{ speciesTypesFlag }}speciesTypesFlag<br>
{{ getDropDownDataAnimalIdentificationFlag }}getDropDownDataAnimalIdentificationFlag<br>
{{ getDropDownDataBirthOriginFlag }}getDropDownDataBirthOriginFlag -->

        <v-card
          elevation="0"
          class="px-5 py-5"
          color="transparent"
          v-if="
            animalToUpdate &&
            animalToUpdate.id &&
            animalCategoriesFlag &&
            breedsFlag &&
            classesFlag &&
            farmsFlag &&
            farmTypesFlag &&
            speciesFlag &&
            speciesTypesFlag &&
            getDropDownDataAnimalIdentificationFlag &&
            getDropDownDataBirthOriginFlag
          "
        >
          <AnimalForm
            @animal:update="updateAnimal"
            :_animal="animalToUpdate"
            :allUserSegments="allUserSegments"
            :animalCategories="animalCategories"
            :breeds="breeds"
            :classes="classes"
            :farms="farms"
            :farmTypes="farmTypes"
            :farmLocations="farmLocations"
            :species="species"
            :speciesTypes="speciesTypes"
            :getDropDownDataAnimalIdentification="
              getDropDownDataAnimalIdentification
            "
            :getDropDownDataBirthOrigin="getDropDownDataBirthOrigin"
          />
        </v-card>

        <prompt-dialog
          @closeDialog="showPromptDialog = false"
          @saveData="saveFormData"
          :dialogI="showPromptDialog"
          v-if="showPromptDialog"
        />
      </v-container>
    </div>
  </div>
</template>

<script>
import loading from "@/mixins/LoadingMixin";
import { animalRules } from "@/validations/AnimalFormRules.js";

import gql from "graphql-tag";
import moment from "moment";
import PromptDialog from "../common/PromptDialog.vue";

import {
  allUserSegments,
  animalCategories,
  breeds,
  classes,
  farms,
  farmTypes,
  generalInfo,
  species,
  speciesTypes,
  getDropDownDataAnimalIdentification,
  getDropDownDataBirthOrigin,
} from "@/graphql/Animals.gql";

import AnimalForm from "./AnimalForm.vue";
import S3UploadServce from "@/_services/S3UploadService";

export default {
  apollo: {

    animalToUpdate: {
      query: generalInfo,
      variables() {
        return { id: parseInt(this.$route.params.animal_number) };
      },
      update: (data) => data.generalInformation,
      result({ data }) {
        const animal = data.generalInformation;

        if (animal.removalInformation == null) {
          animal.removalInformation = {};
        }

        if (animal.animalIdentification == null) {
          animal.animalIdentification = {};
        }

        if (animal.additionalInformation == null) {
          animal.additionalInformation = {};
        }

        if (animal.birthOrigin == null) {
          animal.birthOrigin = {};
        }

        if (animal.parentageInformation == null) {
          animal.parentageInformation = {};
        }

        if (animal.ownerBreedAssociation == null) {
          animal.ownerBreedAssociation = {};
        }

        if (animal.breedId == null) {
          animal.breedId = "9999";
        }

        // if (!animal.birthOrigin.dateOfBirth) {
        //   animal.birthOrigin.dateOfBirth =  new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        //     .toISOString()
        //     .substr(0, 10);
        // }

        if (
          animal.removalInformation &&
          !animal.removalInformation.dateOfRemoval
        ) {
          animal.removalInformation.dateOfRemoval = new Date(
            Date.now() - new Date().getTimezoneOffset() * 60000
          )
            .toISOString()
            .substr(0, 10);
        }

        if (animal.animalIdentification.dateOfRegistration) {
          animal.animalIdentification.dateOfRegistration = moment(
            animal.animalIdentification.dateOfRegistration
          ).format("YYYY-MM-DD");
        }

        if (animal.removalInformation.processingDate) {
          animal.removalInformation.processingDate = moment(
            animal.removalInformation.processingDate
          ).format("YYYY-MM-DD");
        }

        animal.birthOrigin.dateOfBirth = animal.birthOrigin.dateOfBirth
          ? moment(animal.birthOrigin.dateOfBirth).format("YYYY-MM-DD")
          : null;
        animal.removalInformation.dateOfRemoval = moment(
          animal.removalInformation.dateOfRemoval
        ).format("YYYY-MM-DD");
        if (
          animal.animalIdentification.identificationMethods &&
          Array.isArray(animal.animalIdentification.identificationMethods)
        ) {
          animal.animalIdentification.identificationMethods =
            animal.animalIdentification.identificationMethods.map((el) => {
              el.id = el.identification_method_id;
              return el;
            });
        } else if (animal.animalIdentification.identificationMethods) {
          animal.animalIdentification.identificationMethods = [];
        } else {
          animal.animalIdentification.identificationMethods = [];
        }
        this.animalToUpdate = animal;
        console.log(this.animalToUpdate, "animal to update");
      },
    },
    allUserSegments: {
      query: allUserSegments,
      variables() {
        return {
          id: this.$store.getters.getUser.id,
        };
      },
    },

    animalCategories: {
      query: animalCategories,
      result({ data }) {
        this.animalCategoriesFlag = true;
        console.log(data, "datadatadata");
      },
    },
    breeds: {
      query: breeds,
      result({ data }) {
        this.breedsFlag = true;
        console.log(data, "datadatadata");
      },
    },
    classes: {
      query: classes,
      result({ data }) {
        this.classesFlag = true;
        console.log(data, "datadatadata");
      },
    },
    farms: {
      query: farms,
      result({ data }) {
        this.farmsFlag = true;
        console.log(data, "datadatadata");
      },
    },
    farmTypes: {
      query: farmTypes,
      result({ data }) {
        this.farmTypesFlag = true;
        console.log(data, "datadatadata");
      },
    },
    farmLocations:{
      query(){
        if(this.animalToUpdate.farmId){
          return gql`
              query framLocations($farmId: Float!){
                farmLocations(farmId:$farmId){
                  id,
                  address,
                  farmData{
                    farmName
                  }
                },
              }
            `;
          }
        },
      variables() {
        return {
          farmId: this.animalToUpdate.farmId,
        };
      },
    },
    species: {
      query: species,
      result({ data }) {
        this.speciesFlag = true;
        console.log(data, "datadatadata");
      },
    },
    speciesTypes: {
      query: speciesTypes,
      result({ data }) {
        this.speciesTypesFlag = true;
        console.log(data, "datadatadata");
      },
    },
    getDropDownDataAnimalIdentification: {
      query: getDropDownDataAnimalIdentification,
      result({ data }) {
        this.getDropDownDataAnimalIdentificationFlag = true;
        console.log(data, "datadatadata");
      },
    },
    getDropDownDataBirthOrigin: {
      query: getDropDownDataBirthOrigin,
      result({ data }) {
        this.getDropDownDataBirthOriginFlag = true;
        console.log(data, "datadatadata");
      },
    },
  },
  components: {
    "prompt-dialog": PromptDialog,
    AnimalForm,
  },
  beforeRouteLeave(to, from, next) {
    if (this.promptNextRoute) {
      next();
    } else {
      if (this.hasChanged) {
        this.promptToRoute = to;
        this.showPromptDialog = true;
      } else {
        next();
      }
    }
  },
  computed: {
    // extension() {
    //   return (this.animalPicture) ? this.animalPicture.name.split('.').pop() : '';
    // }
    hasChanged() {
      return true;
    },
  },

  data() {
    return {
      animalToUpdateFlag: false,
      animalCategoriesFlag: false,
      breedsFlag: false,
      classesFlag: false,
      farmsFlag: false,
      farmTypesFlag: false,
      speciesFlag: false,
      speciesTypesFlag: false,
      getDropDownDataAnimalIdentificationFlag: false,
      getDropDownDataBirthOriginFlag: false,

      getDropDownDataAnimalIdentification: {},
      getDropDownDataBirthOrigin: {},
      animal: {},
      breeds: [],
      animalToUpdate: {},
      today: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      animalProfile: null,
      imageRules: [
        (value) =>
          !value ||
          value.size < 1000000 ||
          "Avatar size should be less than 1 MB!",
      ],
      animalRules,
      panel: 0,
      valid: true,
      animalDOBmenu: false,
      animalRemovalmenu: false,
      birthEaseTypes: [
        { text: "No Assistance", value: "1" },
        { text: "Some Assistance", value: "2" },
        { text: "Mechanical Assistance", value: "3" },
        { text: "A Cesarean section", value: "4" },
        { text: "Abnormal Delivery", value: "5" },
      ],
      genders: [
        { text: "Male", value: "Male" },
        { text: "Female", value: "Female" },
      ],
      animalRemovalReasons: [
        { text: "Sale", value: "1" },
        { text: "Slaughter", value: "2" },
        { text: "Death", value: "3" },
        { text: "Theft", value: "4" },
        { text: "Other", value: "5" },
      ],
      hornStatuses: [
        { text: "Horned", value: "Horned" },
        { text: "Polled", value: "Polled" },
        { text: "Dehorned", value: "Dehorned" },
      ],
      breadcrumbs: [
        {
          text: "Dashboard",
          disabled: false,
          to: "/",
        },
        {
          text: "Animals",
          to: {
            name: "Animals",
          },
          exact: true,
        },
        {
          text: "Edit Animal",
          disabled: true,
        },
      ],
      errors: {
        animalImg: "",
        tagType: "",
        tagNumber: "",
        registrationNumber: "",
        birthWeight: "",
        birthEase: "",
        birthFarmId: "",
        ownerName: "",
        sirePubId: "",
        damPubId: "",
        surrogateDamPubId: "",
        breed: "",
        conceptionMethod: "",
        gender: "",
        dob: "",
        operator: "",
        animalRemovedFarmId: "",
        animalRemovalDate: "",
        removedAnimalDestination: "",
        animalRemovalReason: "",
        name: "",
        trackingNumber: "",
        brand: "",
        tattoo: "",
        hornStatus: "",
        origin: "",
        previousOwnerName: "",
        twin: "",
        breedAssociationName: "",
        breedAssociationRegNo: "",
        breeder: "",
        note: "",
      },
      showPromptDialog: false,
      promptToRoute: null,
      promptNextRoute: false,
      defaultData: {},
    };
  },
  methods: {
    saveFormData(answer) {
      this.showPromptDialog = false;
      if (!answer) {
        this.promptNextRoute = true;
        this.$router.push(this.promptToRoute);
      }
    },
    showHideSection(section) {
      var panel = this.$refs[section];
      panel.style.maxHeight = panel.style.maxHeight
        ? null
        : panel.scrollHeight + "%";
    },
    async updateAnimal(animalToUpdate) {
      this.startLoading();
      console.log("animal to update", animalToUpdate);
      let uploadedImage;

      if (
        animalToUpdate.animalPicture &&
        typeof animalToUpdate.animalPicture == "object"
      ) {
        //file and folder to aws
        uploadedImage = await S3UploadServce.singleUpload(
          animalToUpdate.animalPicture,
          "registration"
        );
        console.log(uploadedImage, "uploadedImageuploadedImageuploadedImage");

        // let uploadedImage = await S3UploadServce.singleUpload(this.selectedFile,'registration');
        // this.file = uploadedImage.fullPath;

        // let uploadedImage = await S3UploadServce.singleUpload(this.selectedFile,'registration');
        // this.file = uploadedImage.fullPath;
      }

      const formData = {
        additionalInformation: {
          animalPicture: uploadedImage ? uploadedImage.fullPath : "",
          id: parseInt(animalToUpdate.additionalInformation.id),
          hornStatus: animalToUpdate.additionalInformation.hornStatus,
          notes: animalToUpdate.additionalInformation.notes,
          twin: !!animalToUpdate.additionalInformation.twin,
          gender: animalToUpdate.additionalInformation.gender,
        },
        animalCategoryId: animalToUpdate.animalCategoryId.map((categoryId) =>
          parseInt(categoryId)
        ),
        // animalIdentification : animalToUpdate.animalIdentification.map(el => {
        //   el.id = parseInt(el.id);
        //   el.additionalIdentificationMethodId = parseInt(el.additionalIdentificationMethodId);
        //   el.dateOfRegistration = el.dateOfRegistration ? moment(el.dateOfRegistration).format('YYYY-MM-DD') : null;
        //   delete el.__typename
        //   return el
        // }),
        // animalIdentification : {...animalToUpdate.animalIdentification[0], id: parseInt(animalToUpdate.animalIdentification[0].id)},
        // animalIdentification: animalToUpdate.animalIdentification,
        animalIdentification: {
          ...animalToUpdate.animalIdentification,
          identificationMethods:
            animalToUpdate.animalIdentification.identificationMethods.map(
              (el) => {
                const modifiedEL = { ...el };

                delete modifiedEL.additionalIdentificationMethod;
                delete modifiedEL.tagCategory;
                return modifiedEL;
              }
            ),
        },
        birthOrigin: {
          id: parseInt(animalToUpdate.birthOrigin.id),
          animalOriginId: animalToUpdate.birthOrigin.animalOriginId
            ? parseInt(animalToUpdate.birthOrigin.animalOriginId)
            : null,
          dateOfBirth: animalToUpdate.birthOrigin.dateOfBirth,
          farmId: animalToUpdate.birthOrigin.farmOriginId,
          conceptionMethodId: animalToUpdate.birthOrigin.conceptionMethodId
            ? parseInt(animalToUpdate.birthOrigin.conceptionMethodId)
            : null,
          conceptionMethod: animalToUpdate.birthOrigin.conceptionMethod,
        },
        breedId: parseInt(animalToUpdate.breedId) == 9999? null : parseInt(animalToUpdate.breedId),
        classId: animalToUpdate.classId.map((animalClass) =>
          parseInt(animalClass)
        ),
        farmId: animalToUpdate.farmId,
        locationId: animalToUpdate.locationId,
        gender: animalToUpdate.gender,
        groupId: animalToUpdate.groupId.map((item) => parseInt(item)),
        ownerBreedAssociation: [
          ...animalToUpdate.ownerBreedAssociation.map((b) => {
            delete b.__typename;
            return b;
          }),
        ],
        parentageInformation: {
          id: parseInt(animalToUpdate.parentageInformation.id),
          damId: animalToUpdate.parentageInformation.damId,
          sireId: animalToUpdate.parentageInformation.sireId,
          surrogateId: animalToUpdate.parentageInformation.surrogateId,
        },
        removalInformation: {
          id: parseInt(animalToUpdate.removalInformation.id),
          processingDate: animalToUpdate.removalInformation.processingDate,
          nameOfOperator: animalToUpdate.removalInformation.nameOfOperator,
          reasonForRemoval: animalToUpdate.removalInformation.reasonForRemoval,
          destinationOfRemoval:
            animalToUpdate.removalInformation.destinationOfRemoval,
          dateOfRemoval: animalToUpdate.removalInformation.dateOfRemoval,
          trackingNumber: animalToUpdate.removalInformation.trackingNumber,
        },
        speciesId: animalToUpdate.speciesId
          ? parseInt(animalToUpdate.speciesId)
          : null,
        zoneId: animalToUpdate.zoneId ? parseInt(animalToUpdate.zoneId) : null,
        speciesTypeId: animalToUpdate.speciesTypeId
          ? parseInt(animalToUpdate.speciesTypeId)
          : null,
        id: parseInt(animalToUpdate.id),
        bullType: animalToUpdate.bullType,
        pregnancyStatus: animalToUpdate.pregnancyStatus,
      };

      this.$apollo
        .mutate({
          // Query
          mutation: gql`
            mutation ($data: UpdateGeneralInformationInput!) {
              updateGeneralInformation(updateGeneralInformationInput: $data) {
                id
              }
            }
          `,
          // Parameters
          variables: {
            data: formData,
          },
        })
        .then((res) => {
          if (res.data.updateGeneralInformation) {
            this.stopLoading();
            this.$notify({
              title: "Animal Updated Successfully",
              text: "", //res.message,
              type: "success",
            });
            this.promptNextRoute = true;
            this.$router.push({
              name: "AnimalDetails",
              params: { animal_number: animalToUpdate.id },
            });
          } else {
            this.stopLoading();
            this.$notify({
              title: "Animal Not Updated",
              text: res.message,
              type: "error",
            });
          }
        })
        .catch(() => {
          // if (data.status == 422) {
          //   data.message.errors.forEach((em) => {
          //     this.errors[em.param] = em.msg;
          //   });
          // }
          this.stopLoading();
        });
    },
  },
  mounted() {},
  mixins: [loading],
};
</script>

<style lang="scss"></style>
